<script setup>

const model = defineModel();

defineProps({
  text: {
    type: String,
    default: "An error occurred while submitting the referral. Please try again."
  },
  timeout: {
    type: Number,
    default: 10000
  }
})

</script>

<template>
  <v-snackbar
      v-model="model"
      :timeout="timeout"
  >
    {{ text }}

    <template v-slot:actions>
      <v-btn
          color="blue"
          variant="text"
          @click="model = false"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<style scoped>

</style>